import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/auth/Login'
import Logout from '@/auth/Logout'

// Containers
import Full from '@/containers/Full'

// Views
import Dashboard from '@/views/Dashboard'
import MyProfile from '@/views/MyProfile'
import UserManagement from '@/views/UserManagement'
import UserManagementDetail from '@/views/UserManagementDetail'
import Accounts from '@/views/Accounts'
import AccountDetail from '@/views/AccountDetail'
import AccountDetailAudit from '@/views/AccountDetailAudit'
import AccountViewNotes from '@/views/AccountViewNotes'
import AccountCreate from '@/views/AccountCreate'
import InventoryDownload from '@/views/InventoryDownload'
import UsageReport from '@/views/UsageReport'
import Heatmap from '@/views/Heatmap'
import ErrorLogs from '@/views/ErrorLogs'
import FullRequestLogs from '@/views/FullRequestLogs'
import ADPDownloadTest from '@/views/ADPDownloadTest'
import StatusUpdates from '@/views/StatusUpdates'
import DataUpdates from '@/views/DataUpdates'
import Enterprise from '@/views/Enterprise'
import EnterpriseDetails from '@/views/EnterpriseDetails'
import PartnerLevelMappings from '@/views/PartnerLevelMappings'
import mDeskingLockouts from '@/views/mDeskingLockouts'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: { roles: ['User', 'Admin','PM'] }
        },
        {
          path: 'UserManagement',
          name: 'User Management',
          component: UserManagement,
          meta: { roles: ['Admin'] }
        },
        {
          path: 'UserManagementDetail/:userId',
          name: 'User Management Detail',
          component: UserManagementDetail,
          meta: { roles: ['Admin'] }
        },
        {
          path: 'PartnerLevelMappings',
          name: 'Partner Level Mappings',
          component: PartnerLevelMappings,
          meta: { roles: ['User', 'Admin', 'PM'] }
        },
        {
          path: 'MyProfile/:notification?',
          name: 'My Profile',
          component: MyProfile,
          meta: { roles: ['User', 'Admin', 'PM'] }
        },
        {
          path: 'accounts',
          name: 'Accounts',
          component: Accounts,
          meta: { roles: ['User', 'Admin', 'PM'] }
        },
        {
          path: 'enterprise',
          name: 'Enterprise',
          component: Enterprise,
          meta: { roles: ['User', 'Admin', 'PM'] }
        },
        {
          path: 'enterprise/details',
          name: 'EnterpriseDetails',
          component: EnterpriseDetails,
          meta: { roles: ['User', 'Admin', 'PM'] }
        },
        {
          path: 'accounts/create',
          name: 'Create Account',
          component: AccountCreate,
          meta: { roles: ['User', 'Admin', 'PM'] }
        },
        {
          path: 'account/:accountId',
          name: 'Account',
          component: AccountDetail,
          meta: { roles: ['User', 'Admin', 'PM'] }
        },
        {
          path: 'accountsaudit/:accountId?',
          name: 'AccountAudit',
          component: AccountDetailAudit,
          meta: { roles: ['User', 'Admin'] }
        },
        {
          path: 'mdeskinglockouts',
          name: 'mDesking Lockouts',
          component: mDeskingLockouts,
          meta: { roles: [ 'Admin'] }
        },
        {
          path: 'accountviewnotes/:accountId?',
          name: 'AccountViewNotes',
          component: AccountViewNotes,
          meta: { roles: ['User', 'Admin','PM'] }
        },
        {
          path: 'inventorydownload',
          name: 'Inventory Download',
          component: InventoryDownload,
          meta: { roles: ['User', 'Admin'] }
        },
        {
          path: 'adpdownloadtest',
          name: 'ADP Download Test',
          component: ADPDownloadTest,
          meta: { roles: ['User', 'Admin'] }
        },
        {
          path: 'usagereport',
          name: 'Usage Report',
          component: UsageReport,
          meta: { roles: ['User', 'Admin','PM'] }
        },
        {
          path: 'mscanheatmap',
          name: 'mScan Heatmap',
          component: Heatmap,
          meta: { roles: ['User', 'Admin', 'PM'] }
        },
        {
          path: 'errorlogs',
          name: 'Error Logs',
          component: ErrorLogs,
          meta: { roles: ['User', 'Admin','PM'] }
        },
        {
          path: 'fullrequestlogs',
          name: 'Full Request Logs',
          component: FullRequestLogs,
          meta: { roles: ['User', 'Admin', 'PM'] }
        },
        {
          path: 'statusupdates',
          name: 'Status Updates',
          component: StatusUpdates,
          meta: { roles: [ 'Admin'] }
        }
        ,
        {
          path: 'dataupdates',
          name: 'Data Updates',
          component: DataUpdates,
          meta: { roles: ['User','Admin'] }
        }
      ],
      meta: { roles: ['User', 'Admin'] }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js